import { QueryTaskParam, QueryTaskResult, GoOnlineModifyPriceItemDetail, QueryItemDetailListUsingGetParams, DownloadFailDetailExcelUsingGetParams, SelectedUpdateOnlinePriceVo, IdVo } from '@servicesTypings/goodsRequest'
import { goodsRequest, goodsBasicRequest } from '@/utils/request'

// 查询任务商品列表
/**
 * 查询任务商品列表
 */
export function queryTaskItemList(data: QueryTaskParam): API.Res<QueryTaskResult[]> {
    return goodsRequest.post('/online/modifyPrice/queryTaskItemList', { data })
}

// 查询可恢复的商品明细列表
/**
 * 查询可恢复的商品明细列表
 */
export function queryCanResetItemDetailList(data: string[]): API.Res<GoOnlineModifyPriceItemDetail[]> {
    return goodsRequest.post('/online/modifyPrice/queryCanResetItemDetailList', { data })
}

// 查询商品明细列表
/**
 * 查询商品明细列表
 */
export function queryItemDetailList(
    params: QueryItemDetailListUsingGetParams
): API.Res<GoOnlineModifyPriceItemDetail[]> {
    return goodsRequest.get('/online/modifyPrice/queryItemDetailList', { params })
}

// 价格恢复任务执行
/**
 * 价格恢复任务执行
 */
export function executeRestPriceJob(data: string[]): API.Res<string> {
    return goodsRequest.post('/online/goods/executeRestPriceJob', { data })
}

// 查询价格浮动比例V2
export function queryPriceFluctuationV2(data) {
    return goodsBasicRequest.get('/supplierConfig/queryPriceFluctuationV2', {
        data
    })
}

// 修改价格浮动比例
export function modifyPriceFluctuation(data) {
    return goodsBasicRequest.post('/supplierConfig/modifyPriceFluctuation', {
        data
    })
}
// 下载失败的同步明细excel
/**
 * 下载失败的同步明细excel
 */
export function downloadFailDetailExcel(params: DownloadFailDetailExcelUsingGetParams): API.Res<string> {
    return goodsRequest.get('/online/modifyPrice/downloadFailDetailExcel', { params })
}

// 根据失败的任务修改线上价格
/**
 * 根据失败的任务修改线上价格
 */
export function updateOnlinePriceByFailTask(data: SelectedUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateOnlinePriceByFailTask', { data })
}

// 根据线上商品ID修改线上价格
/**
 * 根据线上商品ID修改线上价格
 */
export function updateOnlinePriceByOnlineItemId(data: SelectedUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateOnlinePriceByOnlineItemId', { data })
}

// 根据商品编码涉及的线上商品下的所有SKU线上价格
/**
 * 根据商品编码涉及的线上商品下的所有SKU线上价格
 */
export function updateOnlinePriceByAllOnlineSku(data: SelectedUpdateOnlinePriceVo): API.Res<string> {
    return goodsRequest.post('/online/goods/updateOnlinePriceByAllOnlineSku', { data })
}

/**
* 是否有任务 
*/
export function haveTaskUsingGET(): API.Res<boolean> {
    return goodsRequest.get('/online/modifyPrice/haveTask')
}

/**
* 删除待执行的任务 
*/
export function deleteWaitModifyPriceTaskUsingPOST(data: IdVo): API.Res<object> {
    return goodsRequest.post('/online/goods/deleteWaitModifyPriceTask', { data })
}
